// Added useRef
import { useCallback, useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { handlePixelInit } from "../services/tags.js";
import { useForm } from "react-hook-form";
import axios from "axios";
import "../index.css";
import {
  eventClick,
  eventWithFormInfo,
  fieldErrorEvent,
  formAbandonEvent,
  formIntermediateEventOTP,
  formStarts,
  formSubmissionFailEvent,
  formSubmitEvent,
  submitErrorEvent,
} from "../services/adobeDataLayer.js";

// lsq start

import queryString from "query-string";
import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import {
  callLSQLapp,
  encryptBody,
  getFirstNameLastName,
  getLsqLeadBody,
} from "../services/lsq.js";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";
import {
  formatAndValidateE164,
  hashValue,
  setValuesInLocalStorange,
} from "../services/utils.js";
// lsq end

function Form({ customADL, setCustomADL }) {
  let navigate = useNavigate();
  const [name, setname] = useState("");
  // Added Last name
  const [lastname, setlastname] = useState("");

  const [pan, setpan] = useState("");
  const [pincode, setpincode] = useState("");
  const [mobile, setmobile] = useState("");
  const [branch, setbranch] = useState("");
  const [otp, setotp] = useState("");
  const [checkbox, setcheckbox] = useState("");
  const [showPan, setShowPan] = useState("");
  const [newMargin, setNewMargin] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isSalaried, setIsSalaried] = useState("savings");
  const [checked, setChecked] = useState(false);
  const [formStarted, setFormStarted] = useState(false);


  // otpstatus 0 - blank otp field
  // otptatus 1 - resend button enabled on otp field
  // otpstatus 2 - timer enabled on otp field
  const [otpstatus, setOtpstatus] = useState(0);

  // Date Chages Start here
  const [date, setDate] = useState(false);
  const [month, setMonth] = useState(false);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const [dob, setdob] = useState("");
  // End Date Chages

  // lsq integration start
  const [otpsent, setOtpsent] = useState(false);
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [disableBtn, setDistablebtn] = useState(false);
  const [token, setToken] = useState("");
  const [otpdisableBtn, setOtpBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [validpincode, setValidincode] = useState(false);
  const [options, setOptions] = useState([
    { Sol_ID: "00", Branch_Name: "Select Branch", AssignLeadToDista: "" },
  ]);
  const [solId, setSolid] = useState("");
  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [timer, setTimer] = useState(0);
  const [otpDisabled, setOtpDisabled] = useState(false);
  const lastAccessedField = useRef("");
  const [employerName, setEmployerName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [topCorporate, settopCorporate] = useState("");
  const [gcc, setGcc] = useState("");
  const [ppaCode, setPPACode] = useState("");
  const [showDropdown, setShowDropdown] = useState(true);
  const [employerError, setEmployerError] = useState("");
  const [occupation, setOccupation] = useState("");
  const [occupationError, setOccupationError] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [hospitals, setHospitals] = useState([]);
  const [hospitalError, setHospitalError] = useState("");
  const [hospitalGcc, setHospitalGcc] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [colleges, setColleges] = useState([]);
  const [collegeError, setCollegeError] = useState("");
  const [collegeGcc, setCollegeGcc] = useState("");
  const { register, setValue } = useForm();

  const SALARY_LANDING_URL = "https://campaigns.icici.bank.in/casa/savingsAccount/salCorp/main/index.html";
  let cancelToken;
  let isValid = 0;

  // SETINPUTS
  const getMobileDetails = () => {
    const ua = navigator.userAgent;
    const match = ua.match(/\(([^)]+)\)/);
    if (!match) return { Mobile_Brand: "", Mobile_Model: "" };
    const details = match[1];
    // Android: "Linux; Android 13; Samsung SM-G991B" or "Linux; Android 13; Galaxy S21"
    const androidMatch = details.match(/Android[^;]*;\s*([^)]+)/i);
    if (androidMatch) {
      const deviceStr = androidMatch[1].trim().replace(/\s+Build\/.+/, "");
      if (/samsung/i.test(ua)) {
        const modelMatch = deviceStr.match(/SM-[\w]+|Galaxy[\s\w]+/i);
        return { Mobile_Brand: "Samsung", Mobile_Model: modelMatch ? modelMatch[0].trim() : deviceStr };
      }
      if (/redmi|poco/i.test(deviceStr)) {
        return { Mobile_Brand: "Xiaomi", Mobile_Model: deviceStr };
      }
      if (/xiaomi/i.test(ua) || /^mi\s/i.test(deviceStr)) {
        return { Mobile_Brand: "Xiaomi", Mobile_Model: deviceStr };
      }
      const parts = deviceStr.split(/\s+/);
      return { Mobile_Brand: parts[0] || "", Mobile_Model: deviceStr };
    }
    // iOS: "iPhone OS 16_0 like Mac OS X"
    if (/iPhone/i.test(ua)) return { Mobile_Brand: "Apple", Mobile_Model: "iPhone" };
    if (/iPad/i.test(ua)) return { Mobile_Brand: "Apple", Mobile_Model: "iPad" };
    return { Mobile_Brand: "", Mobile_Model: "" };
  };

  // const { Mobile_Brand, Mobile_Model } = getMobileDetails();

  const [inputs, setInputs] = useState({
    User_Agent: navigator.userAgent,
    ApiProductName: "Savings Account",
    CampaignId: "832997",
    source: "Landing Page",
    CompleteUrl: window.location.href,
  });

  const handleSalariedSelection = (choice) => {
    if (choice === "salary") {
      sessionStorage.setItem("accountType", "savings"); // store current page type

      let utmParams = queryString.parse(window.location.search);

      window.location.assign(
        SALARY_LANDING_URL + "?" + queryString.stringify(utmParams)
      );
      return;
    }

    setIsSalaried("savings");
  };

  useEffect(() => {
    const savedType = sessionStorage.getItem("accountType");

    if (savedType === "savings") {
      setIsSalaried("savings");
    } else {
      setIsSalaried("savings"); // default
    }
  }, []);
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    if (inputs.mobile?.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, inputs.mobile, otpsent]);

  // set Fbp, Fbc, UTM parameters value

  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum retries
    const retryInterval = 4000; // Interval between retries in ms

    const getCookieValue = (cookieName) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    };

    const captureCookies = () => {
      const fbpValue = getCookieValue("_fbp") || "";
      const fbcValue = getCookieValue("_fbc") || "";

      setFbp(fbpValue);
      setFbc(fbcValue);

      // Check if retries are needed
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        retryCount++;
        setTimeout(captureCookies, retryInterval); // Retry after the interval
      }
    };

    captureCookies(); // Start capturing cookies on mount
  }, []);

  useEffect(() => {
    if (customADL.formStarts && customADL.cta) {
      if (customADL.formStarts < customADL.cta) {
        formAbandonEvent(lastAccessedField.current);
        setCustomADL({ ...customADL, formStarts: "" });
      }
    }
  }, [customADL]);

  // Logger
  useEffect(() => {
    // console.log("lead payload", inputs)
  }, [inputs]);

  useEffect(() => {
    const onScroll = () => {
      if (!hasScrolled && isSalaried === "") {
        setHasScrolled(true);
        setIsSalaried("savings");
      }
    };

    window.addEventListener("scroll", onScroll, { once: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hasScrolled, isSalaried]);

  useEffect(() => {
    const closeTooltip = () => {
      document
        .querySelectorAll(".info-circle.show-tooltip")
        .forEach((el) => el.classList.remove("show-tooltip"));
    };

    document.addEventListener("click", closeTooltip);
    return () => document.removeEventListener("click", closeTooltip);
  }, []);


  /**
   * this useEffect is being used for sending and verifying otp against the mobile number
   */
  useEffect(() => {
    let mobileVal = inputs["mobile"];
    let OTP = inputs["otp"] ? inputs["otp"] : "";
    if (mobileVal !== undefined) {
      if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
        verifyOTPText(mobileVal, OTP);
      }
    }
  }, [token, inputs["otp"], inputs["mobile"]]);

  const handlePanView = (e) => {
    e.preventDefault();
    setShowPan(!showPan);
  };

  const handleRightCLickTC = (e) => {
    e.preventDefault();
    eventClick("terms and conditions", "link", "form");
  };

  const mainFun = async (mobile) => {
    if ("OTPCredential" in window) {
      const input = document.querySelector(
        'input[autoComplete="one-time-code"]'
      );
      if (!input) return;
      const ac = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: {
            transport: ["sms"],
          },
          signal: ac.signal,
        });
        input.value = otp.code;
        setInputs((inputs) => ({ ...inputs, otp: otp.code }));
        setTimeout(verifyOTPText(mobile, otp.code), 5000);
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
  };

  // sendOTPText otp
  const sendOTPText = async (mobileNumber, option) => {
    if (
      !mobileNumber ||
      mobileNumber.length !== 10 ||
      !mobileNumber.match(/^[6-9]\d{9}$/)
    ) {
      return;
    }
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        setOtpsent(true);
        notifySuccess("OTP has been sent to your mobile number.");
        let otpType = option === "resend" ? "resend" : "send";
        if (option !== "resend") formIntermediateEventOTP(otpType);
        if (option === "resend")
          eventWithFormInfo("resend", "button", "form", "", inputs);
        // setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        await mainFun(mobileNumber);
      } else if (
        otpResponse.data.message.response === "MAX OTP Limit reached"
      ) {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      } else {
        notifyWarn("Please Resend OTP.");
        setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        setOtpsent(false);
      }

      // setMobileval(mobileNumber);
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "BG" };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      notifyWarn("Invalid OTP");
      // fieldErrorEvent("invalid otp", "otp");

      let myInputs = { ...inputs };
      myInputs.otp = "";
      setInputs(myInputs);
      // setResendBtn(true);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    // setResendBtn(false);
    setDistablebtn(true);
    setOtpBtn(true);
    setBtnDisable(false);
    setTimer(0);
    setOtpDisabled(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    formIntermediateEventOTP("verified");

    notifySuccess("OTP Verified Successfully.");
  };

  /**
   * this fn will take pincode and set options for branches to display on UI
   * @param {*} pincode
   */
  async function handleChangePIN(pincode) {
    let PIN = pincode.target.value;
    setInputs((inputs) => ({ ...inputs, ["pincode"]: PIN }));
    if (PIN.length === 6) {
      let payload = { pincode: PIN };
      let param = { type: "SavingsAccountDistaPincode" };
      let response = await callLSQLapp(payload, "MAVIS", param);
      if (response.data.message.Count === 0) {
        setpincode("Please enter valid pincode");
        setInputs((inputs) => ({
          ...inputs,
          branch: "",
          City: "",
          State: "",
        }));
        setSolid("");
        setValidincode(false);
        setNewMargin(true);
      } else {
        setpincode("");
        setValidincode(true);
        setOptions(response.data.message.Data);
        // set solid and branch
        setInputs((inputs) => ({
          ...inputs,
          branch: response.data.message.Data[0].Branch_Name,
          City: response.data.message.Data[0].City,
          State: response.data.message.Data[0].State,
          // AssigntoDista: response.data.message.Data[0].Assign_o_Dista,
          state2: response.data.message.Data[0].state2,
        }));
        setSolid(response.data.message.Data[0].Sol_ID);
      }
      await checkNegative(pincode);
    }
  }


    async function checkNegative(pincode) {
    let PIN = pincode.target.value;
    if (PIN.length === 6) {
      let payload = { pincode: PIN };
      let param = { type: "SavingsAccountNegativePincode" };
      let response = await callLSQLapp(payload, "MAVIS", param);
      const negativePincode =
        response.data.message.Data?.[0]?.Savings_Negative_Pincode ?? "";
      setInputs((inputs) => ({ ...inputs, negativePincode }));

    }
  }
  /**
     * this fn will take pincode and set options for branches to display on UI
    //  *param : Employer Name
     */
  let lastFetchedPrefix = "";
  const onCompanyChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = searchValue.substring(0, 4).toLowerCase();
    const storageKey = `mainOld_company_${prefix}`;

    setEmployerName(inputValue);
    setGcc("");
    setPPACode("");
    handleChange(e);

    const addOthersIfNeeded = (list) => {
      const hasOthers = list.some((item) => item.Company_Name === "Others");
      if (!hasOthers && searchValue.length > 0) {
        return [...list, { Company_Name: "Others", LTF: null }];
      }
      return list;
    };

    const storedData = localStorage.getItem(storageKey);
    const parsedData = storedData ? JSON.parse(storedData) : null;
    // cached entries fetched before PPA_Code support was added won't have the field; treat those as stale so they get refetched
    const isCacheStale =
      parsedData &&
      parsedData.some((item) => item.Company_Name !== "Others" && !("PPA_Code" in item));
    if (isCacheStale) {
      localStorage.removeItem(storageKey);
    }

    if (parsedData && !isCacheStale) {
      const filteredData = parsedData.filter((item) =>
        item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      const finalData = addOthersIfNeeded(filteredData);
      setCompanies(finalData);
    } else if (searchValue.length >= 3 && prefix !== lastFetchedPrefix) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Cancelled due to new request");
      }

      cancelToken = axios.CancelToken.source();

      try {
        const payload = { company: searchValue };
        const param = { type: "savingsNewGCC" };

        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;

        if (Count > 0) {
          localStorage.setItem(storageKey, JSON.stringify(Data));
          lastFetchedPrefix = prefix;

          const filteredData = Data.filter((item) =>
            item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
          );
          const finalData = addOthersIfNeeded(filteredData);
          setCompanies(finalData);
        } else {
          localStorage.setItem(storageKey, JSON.stringify([]));
          lastFetchedPrefix = prefix;
          setCompanies([{ Company_Name: "Others", LTF: null }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Company fetch failed:", error);
        }
      }
    } else {
      setCompanies([]);
    }

  };


  let lastFetchedHospitalPrefix = "";
  let hospitalCancelToken;
  const onHospitalChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = "mainOld_hosp_" + searchValue.substring(0, 4).toLowerCase();

    setHospitalName(inputValue);
    setHospitalGcc("");

    const addHospitalExtras = (list) => {
      const result = list.filter(
        (item) => item.COMPANY_NAME !== "Own clinic" && item.COMPANY_NAME !== "Others"
      );
      return [...result, { COMPANY_NAME: "Own clinic" }, { COMPANY_NAME: "Others" }];
    };

    const storedData = localStorage.getItem(prefix);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filtered = parsedData.filter((item) =>
        item.COMPANY_NAME.toLowerCase().includes(searchValue.toLowerCase())
      );
      setHospitals(addHospitalExtras(filtered));
    } else if (searchValue.length >= 3 && prefix !== lastFetchedHospitalPrefix) {
      if (typeof hospitalCancelToken !== typeof undefined) {
        hospitalCancelToken.cancel("Cancelled due to new request");
      }
      hospitalCancelToken = axios.CancelToken.source();
      try {
        const payload = { company: searchValue };
        const param = { type: "savingsHospital" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;
        if (Count > 0) {
          localStorage.setItem(prefix, JSON.stringify(Data));
          lastFetchedHospitalPrefix = prefix;
          const filtered = Data.filter((item) =>
            item.COMPANY_NAME.toLowerCase().includes(searchValue.toLowerCase())
          );
          setHospitals(addHospitalExtras(filtered));
        } else {
          localStorage.setItem(prefix, JSON.stringify([]));
          lastFetchedHospitalPrefix = prefix;
          setHospitals([{ COMPANY_NAME: "Own clinic" }, { COMPANY_NAME: "Others" }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Hospital fetch failed:", error);
        }
      }
    } else {
      setHospitals([]);
    }
  };

  let lastFetchedCollegePrefix = "";
  let collegeCancelToken;
  const onCollegeChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = "mainOld_col_" + searchValue.substring(0, 4).toLowerCase();

    setCollegeName(inputValue);
    setCollegeGcc("");

    const addCollegeOthers = (list) => {
      const hasOthers = list.some((item) => item.Institute_Name === "Others");
      if (!hasOthers && list.length > 0) {
        return [...list, { Institute_Name: "Others" }];
      }
      return list;
    };

    const storedData = localStorage.getItem(prefix);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filtered = parsedData.filter((item) =>
        item.Institute_Name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setColleges(addCollegeOthers(filtered));
    } else if (searchValue.length >= 3 && prefix !== lastFetchedCollegePrefix) {
      if (typeof collegeCancelToken !== typeof undefined) {
        collegeCancelToken.cancel("Cancelled due to new request");
      }
      collegeCancelToken = axios.CancelToken.source();
      try {
        const payload = { company: searchValue };
        const param = { type: "savingsCollege" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;
        if (Count > 0) {
          localStorage.setItem(prefix, JSON.stringify(Data));
          lastFetchedCollegePrefix = prefix;
          const filtered = Data.filter((item) =>
            item.Institute_Name.toLowerCase().includes(searchValue.toLowerCase())
          );
          setColleges(addCollegeOthers(filtered));
        } else {
          localStorage.setItem(prefix, JSON.stringify([]));
          lastFetchedCollegePrefix = prefix;
          setColleges([{ Institute_Name: "Others" }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("College fetch failed:", error);
        }
      }
    } else {
      setColleges([]);
    }
  };

  // lsq integration end

  const handleChange = (event) => {
    setCustomADL({ ...customADL, formStarts: Date.now() });
    if (!formStarted) {
      formStarts();
      setCustomADL({ ...customADL, formStarts: Date.now() });
      setFormStarted(true);
    }

    var name = event.target.name;
    var value = event.target.value;

    if (name === "pan") {
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");

      if (value.length <= 5 && /[^a-zA-Z]/.test(value)) {
        value = value.slice(0, -1);
      }

      if (
        value.length > 5 &&
        value.length <= 9 &&
        /^[^0-9]+$/.test(value.slice(5, 9))
      ) {
        value = value.slice(0, -1);
      }

      if (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1))) {
        value = value.slice(0, -1);
      }
    }

    // we are setting solID here against the branchName
    if (name === "branch") {
      const selectedOptionSolid =
        event.target.options[event.target.selectedIndex].getAttribute("solid");
      setSolid(selectedOptionSolid.toString());
    }


    // dob Changes Start

    // Date validate date and change focus
    if (name === "dob") {
      if (value.length === 2 && value === "00") {
        value = "";
        setDate(value);
      }
      if (value.length === 1 && value >= 1 && value <= 3) {
        setDate(value);
      } else if (value.length === 1 && value >= 4 && value <= 9) {
        setDate("0" + value);
        monthRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 31) {
        setDate(value);
        monthRef.current.focus();
      } else if (value >= 32) {
        setDate(value.slice(0, 1));
      } else {
        setDate(value);
        // console.log(date)
      }
    }

    // // Month validate date and change focus
    if (name === "dob_month") {
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        if (value === 2 && date >= 30) {
          setDate("");
          dayRef.current.focus();
        } else {
          yearRef.current.focus();
        }
        setMonth("0" + value);
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
        // console.log(month)
      }
    }

    // // Year validate date and change focus
    if (name === "dob_month") {
      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }
      if (value.length === 2 && value === "00") {
        value = "";
        setMonth(value);
      }
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        setMonth("0" + value);
        yearRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
      }
    }

    if (name === "dob_year") {
      if (value.length === 1) {
        if (value !== "1" && value !== "2") {
          value = "";
        }
      }

      if (value.length === 2) {
        if (value !== "19" && value !== "20") {
          value = value.slice(0, -1);
        }
      }
      // MAX AGE
      let yearStart = new Date().getFullYear() - 70;
      var year = new Date().getFullYear();

      if (value.length === 4 && value < yearStart) {
        value = value.slice(0, -1);
      }

      if (value.length === 4 && value > year) {
        value = value.slice(0, -1);
      }

      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }

      if (month >= 1 && month <= 9 && month.length === 1) {
        setMonth("0" + month);
      }
    }
    // dob Changes End

    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleBlur = (event) => {
    const name = event.target.name;
    lastAccessedField.current = name;
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

    const name_reg = /^[a-zA-Z ]*$/;
    const short_name_reg = /^([a-zA-Z]\s[a-zA-Z]{1,2}|[a-zA-Z]{2}\s[a-zA-Z])$/;

    if (name === "name") {
      const trimmedName = inputs.name ? inputs.name.trim() : "";
      if (
        inputs.name === "" ||
        inputs.name === undefined ||
        trimmedName.length <= 2
      ) {
        setname("Please enter your full name.");
        fieldErrorEvent("Please enter your full name.", "name");
        isValid++;
      } else {
        if (!inputs.name.match(name_reg) || short_name_reg.test(trimmedName)) {
          setname("Please enter valid full name.");
          fieldErrorEvent("Please enter valid full name.", "name");

          isValid++;
        } else {
          setname("");
        }
      }
    }

    if (name === "mobile") {
      if (!inputs.mobile) {
        setmobile("Please enter your mobile number.");
        fieldErrorEvent("Please enter your mobile number.", "mobile");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.mobile.match(mobile_reg) || /^(\d)\1{9}$/.test(inputs.mobile) || /^(\d{2})\1{4}$/.test(inputs.mobile)) {
          setmobile("Please enter valid mobile number.");
          fieldErrorEvent("Please enter valid mobile number.", "mobile");

          setNewMargin(true);
          isValid++;
        } else {
          setmobile("");
        }
      }
    }

    if (name === "pan") {
      if (!inputs.pan) {
        setpan("Please enter your pan number.");
        fieldErrorEvent("Please enter your pan number.", "pan");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.pan.match(regpan)) {
          setpan("Please enter valid pan number.");
          fieldErrorEvent("Please enter valid pan number.", "pan");
          setNewMargin(true);
          isValid++;
        } else {
          setpan("");
        }
      }
    }

    if (name === "occupation") {
      if (!occupation || occupation === "") {
        setOccupationError("Please select your occupation.");
        fieldErrorEvent("Please select your occupation.", "occupation");
        isValid++;
      } else {
        setOccupationError("");
      }
    }

    if (name === "employer_name" && occupation === "Salaried Professional") {
      if (!employerName || employerName.trim() === "") {
        setEmployerError(" Please enter your employer name");
        fieldErrorEvent("Please enter your employer name", "employer_name");
        isValid++;
      } else {
        if (!gcc) {
          setEmployerName("Others");
          setGcc("Others");
        }
        setEmployerError("");
      }
    }

    if (name === "hospital_name" && occupation === "Doctor") {
      if (!hospitalName || hospitalName.trim() === "") {
        setHospitalError(" Please enter your hospital name.");
        fieldErrorEvent("Please enter your hospital name.", "hospital_name");
        isValid++;
      } else {
        setHospitalError("");
      }
    }

    if (name === "college_name" && occupation === "Student") {
      if (!collegeName || collegeName.trim() === "") {
        setCollegeError(" Please enter your college name.");
        fieldErrorEvent("Please enter your college name.", "college_name");
        isValid++;
      } else {
        if (!collegeGcc) {
          setCollegeName("Others");
          setCollegeGcc("Others");
        }
        setCollegeError("");
      }
    }

    if (name === "pincode") {
      var pincode_reg = /^[1-9][0-9]{5}$/;
      if (!inputs.pincode) {
        setpincode("Please enter valid pincode.");
        fieldErrorEvent("Please enter valid pincode.", "pincode");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.pincode.match(pincode_reg) || !validpincode) {
          setpincode("Please enter valid pincode.");
          fieldErrorEvent("Please enter valid pincode.", "pincode");
          setNewMargin(true);
          isValid++;
        } else {
          setpincode("");
        }
      }
    }

    if (name === "otp") {
      var otp_reg = /^[0-9]{6}$/;
      if (!inputs.otp) {
        setotp("Please enter valid otp.");
        fieldErrorEvent("Please enter valid otp.", "otp");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.otp.match(otp_reg)) {
          setotp("Please enter valid otp number.");
          fieldErrorEvent("Please enter valid otp number.", "otp");
          setNewMargin(true);
          isValid++;
        } else {
          setotp("");
        }
      }
    }

    if (name === "branch") {
      if (!inputs.branch) {
        setbranch("Please select branch.");
        fieldErrorEvent("Please select branch.", "branch");
        setNewMargin(true);
        isValid++;
      }

      if (validpincode && inputs.branch) {
        setbranch("");
      }
    }

    // dob Changes Start

    if (name === "dob" || name === "dob_month" || name === "dob_year") {
      var year = new Date().getFullYear();
      var yearStart = new Date().getFullYear() - 110;
      var dob_error = false;
      if (
        name === "dob" &&
        inputs.dob !== "undefined" &&
        !(inputs.dob >= 1 && inputs.dob <= 31)
      ) {
        isValid++;
        dob_error = true;
        setdob("Please enter valid Date Of Birth.");
        fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
      } else {
        dob_error = false;

        setdob("");
      }

      if (name === "dob_month" && !dob_error) {
        if (
          typeof inputs.dob_month !== "undefined" &&
          !(inputs.dob_month >= 1 && inputs.dob_month <= 12)
        ) {
          isValid++;
          dob_error = true;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          dob_error = false;
          setdob("");
        }
      }

      if (name === "dob_year" && !dob_error) {
        if (!inputs.dob_year) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else if (
          (typeof inputs.dob_year !== "undefined" &&
            inputs.dob_year < yearStart) ||
          inputs.dob_year >= year
        ) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          setdob("");
        }
      }
    }
    // dob Changes End
  };

  const errorRef = useRef({});
  const handleSubmit = async (event) => {

    event.preventDefault();
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    const name_reg = /^[a-zA-Z ]*$/;
    const short_name_reg = /^([a-zA-Z]\s[a-zA-Z]{1,2}|[a-zA-Z]{2}\s[a-zA-Z])$/;

    const trimmedName = inputs.name ? inputs.name.trim() : "";
    if (
      inputs.name === "" ||
      inputs.name === undefined ||
      trimmedName.length <= 2
    ) {
      setname("Please enter your full name");
      errorRef.current.name = "Please enter your full name";
      isValid++;
    } else {
      if (!inputs.name.match(name_reg) || short_name_reg.test(trimmedName)) {
        setname("Please enter valid full name");
        errorRef.current.name = "Please enter valid full name";

        isValid++;
      } else {
        setname("");
      }
    }

    if (!inputs.branch && validpincode) {
      setbranch("Please select branch.");
      errorRef.current.branch = "Please select branch.";

      setNewMargin(true);
      isValid++;
    }

    if (!inputs.mobile) {
      setmobile("Please enter your mobile number.");
      errorRef.current.number = "Please enter your mobile number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.mobile.match(mobile_reg)) {
        setmobile("Please enter valid mobile number.");
        errorRef.current.number = "Please enter valid mobile number.";

        isValid++;
      } else {
        setmobile("");
      }
    }

    var otp_reg = /^[0-9]{6}$/;
    if (!inputs.otp) {
      setotp("Please enter valid otp.");
      errorRef.current.otp = "Please enter valid otp.";
      isValid++;
    } else {
      if (!inputs.otp.match(otp_reg)) {
        setotp("Please enter valid otp number.");
        errorRef.current.otp = "Please enter valid otp.";

        isValid++;
      } else {
        setotp("");
      }
    }

    if (!inputs.pan) {
      setpan("Please enter your pan number.");
      errorRef.current.pan = "Please enter your pan number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pan.match(regpan)) {
        setpan("Please enter valid pan number.");
        errorRef.current.pan = "Please enter valid pan number.";
        isValid++;
      } else {
        setpan("");
      }
    }

    var pincode_reg = /^[1-9][0-9]{5}$/;
    if (!inputs.pincode) {
      setpincode("Please enter valid pincode.");
      errorRef.current.pincode = "Please enter valid pincode.";

      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pincode.match(pincode_reg) || !validpincode) {
        setpincode("Please enter valid pincode.");
        errorRef.current.pincode = "Please enter valid pincode.";
        isValid++;
      } else {
        setpincode("");
      }
    }
    if (checked === false) {
      setcheckbox(
        "Please accept our terms and conditions by clicking on the checkbox."
      );
      errorRef.current.checkbox =
        "Please accept our terms and conditions by clicking on the checkbox.";

      setNewMargin(true);
      isValid++;
    } else {
      setcheckbox("");
    }

    if (!occupation || occupation === "") {
      setOccupationError("Please select your occupation.");
      errorRef.current.occupation = "Please select your occupation.";
      isValid++;
    } else {
      setOccupationError("");
    }

    if (occupation === "Salaried Professional") {
      if (!employerName || employerName.trim() === "") {
        setEmployerError(" Please enter your employer name.");
        errorRef.current.employer = " Please enter your employer name.";
        isValid++;
      } else {
        setEmployerError("");
      }
    }

    if (occupation === "Doctor") {
      if (!hospitalName || hospitalName.trim() === "") {
        setHospitalError(" Please enter your hospital name.");
        errorRef.current.hospitalName = " Please enter your hospital name.";
        isValid++;
      } else {
        setHospitalError("");
      }
    }

    if (occupation === "Student") {
      if (!collegeName || collegeName.trim() === "") {
        setCollegeError(" Please enter your college name.");
        errorRef.current.collegeName = " Please enter your college name.";
        isValid++;
      } else {
        setCollegeError("");
      }
    }

    if (isValid === 0) {
      // notifyWarn("This may take upto 15 seconds. Please do not reload the page!")
      setApplyBtnDisable(true);

      // GET UTM DETAILS
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      const { firstName, lastName } = getFirstNameLastName(inputs.name);

      const payloadInputs = {
        ...inputs,
        token: token,
        solId: solId,
        isChecked: checked,
        FBPixelID: fbp,
        FBClickID: fbc,
        firstname: firstName,
        lastname: lastName,
        // MobileDetails: { Mobile_Brand, Mobile_Model },
      };

      payloadInputs.occupation = occupation;
      if (occupation === "Salaried Professional") {
        payloadInputs.companyName = employerName || "";
        payloadInputs.gcc = employerName?.toLowerCase() === "others" ? "Others" : gcc || "";
        payloadInputs.ppaCode = employerName?.toLowerCase() === "others" ? "Others" : ppaCode || "";
        payloadInputs.otherCompany = "";
      } else if (occupation === "Doctor") {
        payloadInputs.companyName = hospitalName || "";
        payloadInputs.gcc = hospitalGcc || "";
      } else if (occupation === "Student") {
        payloadInputs.companyName = collegeName || "";
        payloadInputs.gcc = collegeGcc || "";
      }
      let lsqInputs = getLsqLeadBody(payloadInputs);
      let payload = {
        mobile: payloadInputs.mobile,
        otp: payloadInputs.otp,
        formdata: lsqInputs,
      };
      let param = { productType: "BG" };
      //  console.log("final input values", lsqInputs);
      // Encrypt Payloads
      const encryptedPayload = await encryptBody(payload);
      const createLeadResp = await callLSQLapp(
        encryptedPayload,
        "CREATE",
        param
      );

      // ? IF Lead Created
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        // handlePixelInit();
        if (inputs.mobile) {
          const formattedMobile = formatAndValidateE164(inputs.mobile);
          const hashedMobile = await hashValue(formattedMobile);
          setValuesInLocalStorange("userData", "", hashedMobile);
        }

        formSubmitEvent(inputs, true);
        navigate(`/thankyou?id=${leadid}`);
      } else {
        setApplyBtnDisable(false);
        formSubmissionFailEvent();
        window.alert("Some error occured! Please try again after some time.");
        // window.location.reload();
      }
      // navigate("/thankyou");
    } else {
      isValid = 0;
      setNewMargin(true);
      submitErrorEvent(errorRef.current);
      return false;
    }
  };

  return (
    <article
      className={`banner_section position-relative  ${newMargin ? "m_update" : null
        }`}
    >
      <div className="banner_img">
        <picture>
          <source
            rel="preload"
            media="(max-width:428.5px)"
            srcSet="dist/img/ICICI_SavingAccount_Banner_mobile.webp"
            alt="ICICI Bank saving account banner"
            width={428}
            height={320}
            className="img-fluid"
          />
          <source
            rel="preload"
            media="(max-width:991.5px)"
            srcSet="dist/img/ICICI_SavingAccount_Banner_ipad.webp"
            alt="ICICI Bank saving account banner"
            width={768}
            height={574}
            className="img-fluid"
          />
          <img
            rel="preload"
            src="dist/img/ICICI_SavingAccount_Banner_desktop.webp"
            alt="Banner img"
            width={2560}
            height={893}
            className="img-fluid"
          />
        </picture>
      </div>
      <div className="saving_account_content"></div>
      <article className="digital_saving container-fluid">
        <div className="container">
          <p>
            With <b>iMobile</b> and <b>Internet Banking</b>, now manage your
            account{" "}
            <em>
              <b>Anytime, Anywhere</b>
            </em>
            .
          </p>
        </div>
      </article>
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="form_wrap" id="saving_account">
              <div className="form_heading">
                <h4>
                  Savings Account opening <br />
                  at your Doorstep
                </h4>
              </div>

              {/* ================= PRE FORM (INSIDE SAME WHITE BOX) ================= */}

              <section className="personal-details">
                <div className="col-12 my-3">
                  <p style={{ fontSize: "16px", fontWeight: 500 }}>
                    Which type of account would you like to open?
                  </p>

                  <div style={{ marginTop: "12px" }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <input
                        type="radio"
                        name="accountType"
                        checked={isSalaried === "savings"}
                        onChange={() => handleSalariedSelection("savings")}
                      />



                      Savings Account
                    </label>

                    {/* <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            if (e.target.checked)
                              handleSalariedSelection("salary");
                          }}
                        />
                        Salary Account
                      </label> */}
                    <label
                      className="account-option"
                    >
                      <input
                        type="radio"
                        name="accountType"
                        checked={isSalaried === "salary"}
                        onChange={() => handleSalariedSelection("salary")}
                      />


                      <span className="account-text">
                        Salary Account
                      </span>

                      <span
                        className="info-circle salary-info"
                        onClick={(e) => {
                          e.preventDefault();   // THIS STOPS LABEL - CHECKBOX
                          e.stopPropagation(); // THIS STOPS EVENT BUBBLING
                          e.currentTarget.classList.toggle("show-tooltip");
                        }}

                      >

                        i
                        <span className="tooltip-box">
                          <strong>Account for Salaried Professionals</strong>
                          <ul>
                            <li>• For monthly salary credit</li>
                            <li>• No minimum balance required</li>
                            <li>• Unlimited ATM transactions</li>
                          </ul>
                        </span>
                      </span>
                    </label>


                  </div>
                </div>
              </section>


              {/* ================= MAIN FORM ================= */}
              {isSalaried === "savings" && (
                <form name="contactForm" method="post" onSubmit={handleSubmit} className="contact-form">
                  <section className="personal-details">
                    {/* =========== first name and last name start =============*/}
                    <div className="col-12 my-2">
                      <div className="row">
                        <div className="col-12 my-2">
                          <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            id="name"
                            value={
                              inputs.name
                                ? inputs.name.replace(/[^a-z ]/gi, "")
                                : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^a-zA-Z\s]/gi,
                              ""
                            ))
                            }
                            className={name !== "" ? "errBrdr" : ""}
                          />

                          <span
                            className="d-block pan_name px-0 mx-1"
                            style={{ fontWeight: "bold", color:'grey' }}
                          >
                            As per PAN
                          </span>
                          {name !== "" ? (
                            <span
                              style={{
                                fontSize: "12px",
                                fontFamily: "sans-serif",
                                fontStretch: "normal",
                                fontStyle: "12px",
                                fontWeight: 400,
                                lineHeight: "normal",
                                letterSpacing: "normal",
                                left: "15px",
                                bottom: 0,
                                color: "red",
                              }}
                            >
                              {name}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    {/* =========== date of birth field end =========== */}
                    <div className="col-12 my-2">
                      <input
                        type={`${showPan ? "text" : "password"}`}
                        name="pan"
                        placeholder="PAN"
                        id="pan"
                        value={inputs.pan ? inputs.pan : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                      />
                      <button
                        onClick={handlePanView}
                        aria-label="Eye"
                        className="show-pan"
                      >
                        <FaEye />
                      </button>
                    </div>
                    {pan !== "" ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          left: "15px",
                          bottom: 0,
                          color: "red",
                        }}
                      >
                        {pan}
                      </span>
                    ) : null}
                    <div className="autocomplete">
                      <input
                        className=""
                        type="number"
                        min="0"
                        placeholder="Pincode of your current address"
                        id="pincode"
                        name="pincode"
                        value={
                          inputs.pincode > 0
                            ? inputs.pincode.replace(/^0+/, "")
                            : ""
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 6))
                        }
                        onChange={handleChangePIN}
                        onBlur={handleBlur}
                      />
                    </div>
                    {pincode !== "" ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          left: "15px",
                          bottom: 0,
                          color: "red",
                        }}
                      >
                        {pincode}
                      </span>
                    ) : null}

                    <div
                      className="col-12 my-2"
                      style={{
                        display:
                          inputs["pincode"]?.length === 6 &&
                            pincode === "" &&
                            validpincode
                            ? "block"
                            : "none",
                      }}
                    >
                      <select
                        className="col-12 my-2"
                        name="branch"
                        id="branch"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        {options.map((option) => (
                          <option
                            key={option.Sol_ID}
                            value={option.Branch_Name}
                            solid={option.Sol_ID}
                            data-assign-lead-to-dista={option.AssignLeadToDista}
                          >
                            {option.Branch_Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {branch !== "" ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          left: "15px",
                          bottom: 0,
                          color: "red",
                        }}
                      >
                        {branch}
                      </span>
                    ) : null}

                    {/* =========== Occupation dropdown =========== */}
                    <div className="col-12 my-2 position-relative">
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div style={{ position: "relative", flex: 1 }}>
                          <select
                            name="occupation"
                            id="occupation"
                            value={occupation}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              const val = e.target.value;
                              setOccupation(val);
                              setEmployerName("");
                              setGcc("");
                              setPPACode("");
                              setCompanies([]);
                              setEmployerError("");
                              setHospitalName("");
                              setHospitals([]);
                              setHospitalError("");
                              setHospitalGcc("");
                              setCollegeName("");
                              setColleges([]);
                              setCollegeError("");
                              setCollegeGcc("");
                              handleChange(e);
                            }}
                            className={occupationError !== "" ? "errBrdr" : ""}
                            style={{ width: "100%", color: 'grey', appearance: "none", WebkitAppearance: "none", paddingRight: "28px" }}
                          >
                            <option value="" disabled>Select your occupation</option>
                            <option value="Salaried Professional">Salaried Professional</option>
                            <option value="Doctor">Doctor</option>
                            <option value="Student">Student</option>
                            <option value="Chartered Accountant">Chartered Accountant</option>
                            <option value="Business owner/Self-employed">Business owner/Self-employed</option>
                            <option value="Others">Others</option>
                          </select>
                          <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: "12px", color: "#555" }}>▼</span>
                        </div>
                        <span
                          className="info-circle"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.currentTarget.classList.toggle("show-tooltip");
                          }}
                        >
                          i
                          <span className="tooltip-box occupation-tool-tip">
                            This helps us fast-track the process
                          </span>
                        </span>
                      </div>
                      {occupationError !== "" && (
                        <span style={{ fontSize: "12px", color: "red" }}>
                          {occupationError}
                        </span>
                      )}
                    </div>

                    {/* =========== Employer name (Salaried Professional only) =========== */}
                    {occupation === "Salaried Professional" && (
                      <div className="col-12 my-2 position-relative">
                        <input
                          type="text"
                          name="employer_name"
                          placeholder="Enter your employer name"
                          id="employer_name"
                          value={employerName}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            onCompanyChange(e);
                            handleChange(e);
                          }}
                          className={employerError !== "" ? "errBrdr" : ""}
                        />
                        {employerError !== "" && (
                          <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                            {employerError}
                          </span>
                        )}
                        {showDropdown && companies.length > 0 && (
                          <ul className="company-dropdown">
                            {companies.map((item) => (
                              <li
                                className="company-List"
                                key={item.Company_Name}
                                onClick={() => {
                                  if (item.Company_Name === "Others") {
                                    setEmployerName("Others");
                                    setGcc("Others");
                                    setPPACode("Others");
                                  } else {
                                    setEmployerName(item.Company_Name);
                                    setGcc(item.GCC);
                                    setPPACode(item.PPA_Code);
                                  }
                                  setCompanies([]);
                                  setEmployerError("");
                                  setValue("companyName", item.Company_Name);
                                }}
                              >
                                {item.Company_Name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}

                    {/* =========== Hospital name (Doctor only) =========== */}
                    {occupation === "Doctor" && (
                      <div className="col-12 my-2 position-relative">
                        <input
                          type="text"
                          name="hospital_name"
                          placeholder="Enter hospital name"
                          id="hospital_name"
                          value={hospitalName}
                          onBlur={handleBlur}
                          onChange={onHospitalChange}
                          className={hospitalError !== "" ? "errBrdr" : ""}
                        />
                        {hospitalError !== "" && (
                          <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                            {hospitalError}
                          </span>
                        )}
                        {hospitals.length > 0 && (
                          <ul className="company-dropdown">
                            {hospitals.map((item) => (
                              <li
                                className="company-List"
                                key={item.COMPANY_NAME}
                                onClick={() => {
                                  setHospitalName(item.COMPANY_NAME);
                                  setHospitals([]);
                                  setHospitalError("");
                                  const isOther = item.COMPANY_NAME === "Own clinic" || item.COMPANY_NAME === "Others";
                                  setHospitalGcc(isOther ? "Others" : "GCC");
                                }}
                              >
                                {item.COMPANY_NAME}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}

                    {/* =========== College name (Student only) =========== */}
                    {occupation === "Student" && (
                      <div className="col-12 my-2 position-relative">
                        <input
                          type="text"
                          name="college_name"
                          placeholder="Enter college name"
                          id="college_name"
                          value={collegeName}
                          onBlur={handleBlur}
                          onChange={onCollegeChange}
                          className={collegeError !== "" ? "errBrdr" : ""}
                        />
                        {collegeError !== "" && (
                          <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                            {collegeError}
                          </span>
                        )}
                        {colleges.length > 0 && (
                          <ul className="company-dropdown">
                            {colleges.map((item) => (
                              <li
                                className="company-List"
                                key={item.Institute_Name}
                                onClick={() => {
                                  setCollegeName(item.Institute_Name);
                                  setColleges([]);
                                  setCollegeError("");
                                  setCollegeGcc(item.Institute_Name === "Others" ? "Others" : "GCC");
                                }}
                              >
                                {item.Institute_Name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}


                    <div className="my-2">
                      <span className="position-relative ">
                        <span className=" number-span ">+91 </span>
                        <input
                          readOnly={disableBtn}
                          type="number"
                          name="mobile"
                          placeholder="Mobile number"
                          value={
                            inputs.mobile > 0
                              ? inputs.mobile.replace(/^[0-5]+/, "")
                              : ""
                          }
                          pattern="\d{10}"
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 10))
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                            if (val.length > 0 && !/^[6-9]/.test(val)) {
                              setmobile("Please enter valid mobile number.");
                            } else if (val.length === 10 && (/^(\d)\1{9}$/.test(val) || /^(\d{2})\1{4}$/.test(val))) {
                              setmobile("Please enter valid mobile number.");
                            } else {
                              setmobile("");
                            }
                          }}
                          id="mobile_number"
                          style={{ textAlign: "left" }}
                          className={mobile !== "" ? "errBrdr" : "errBrdr"}
                          onWheel={(e) => e.target.blur()}
                        />

                        {!otpsent && (
                          <button
                            type="button"
                            className="btn"
                            id="resendBtn"
                            onClick={() => sendOTPText(inputs.mobile, "send")}
                            style={{ display: resendBtnDisplay }}
                            disabled={otpDisabled || !(
                              /^[6-9]\d{9}$/.test(inputs.mobile) &&
                              !/^(\d)\1{9}$/.test(inputs.mobile) &&
                              !/^(\d{2})\1{4}$/.test(inputs.mobile)
                            )}
                          >
                            Send OTP
                          </button>
                        )}

                        {inputs.mobile?.length === 10 && otpsent && timer <= 0 ? (
                          <button
                            type="button"
                            className="btn"
                            id="resendBtn"
                            onClick={() => sendOTPText(inputs.mobile, "resend")}
                            style={{ display: resendBtnDisplay }}
                            disabled={otpDisabled}
                          >
                            {otpBtnText}
                          </button>
                        ) : (
                          <span
                            className="Timer"
                            id="timer"
                            style={{ display: timerDisplay }}
                          >
                            {" "}
                            00:
                            {timer.toString().length < 2
                              ? timer.toString().padStart(2, "00")
                              : timer}
                          </span>
                        )}
                      </span>
                    </div>
                    {mobile !== "" ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          left: "15px",
                          bottom: 0,
                          color: "red",
                        }}
                      >
                        {mobile}
                      </span>
                    ) : null}
                    {/* Css Class added for full length blank otp field  */}
                    <div
                      className={
                        otpstatus === 0
                          ? " align-items-center w-100 mt-1"
                          : "d-flex align-items-center w-75 mt-1"
                      }
                    >
                      <input
                        autoComplete="one-time-code"
                        value={inputs["otp"] ? inputs["otp"] : ""}
                        readOnly={disableBtn}
                        type="number"
                        min="0"
                        name="otp"
                        pattern="\d{6}"
                        placeholder="OTP"
                        id="otp"
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 6))
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {/* =========== timer and resend button start =============*/}
                      {otpstatus === 2 ? (
                        <div className="timer_wrapper text-center ms-1">
                          <span id="timer">00:00</span>
                        </div>
                      ) : (
                        ""
                      )}
                      {otpstatus === 1 ? (
                        <div className="resend_btn ms-1">
                          <button>Resend</button>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* =========== timer and resend button end =============*/}
                    </div>
                    {otp !== "" ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontFamily: "sans-serif",
                          fontStretch: "normal",
                          fontStyle: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "normal",
                          left: "15px",
                          bottom: 0,
                          color: "red",
                        }}
                      >
                        {otp}
                      </span>
                    ) : null}
                    <p style={{ color: "#DB6322", fontSize: "12px", marginTop: "8px", marginBottom: "8px" }}>
                      <strong>Note:</strong> Minimum balance requirement applicable as per account type.
                    </p>
                    <div className="checkbox row">
                      <div className="col-1 check-input">
                        <input
                          type="checkbox"
                          name="checkbox"
                          onChange={handleChange}
                          defaultChecked={checked}
                          onClick={() => {
                            setChecked(!checked);
                            eventWithFormInfo(
                              "terms & conditions",
                              "checkbox",
                              "form",
                              "",
                              inputs
                            );
                          }}
                          id="checkbox"
                        />
                      </div>
                      <div className="col-11 p-0 ">
                        <label htmlFor="checkbox">
                          I consent to be contacted by ICICI Bank
                          regarding this product via Call/ SMS/ Email/
                          WhatsApp/ RCS. I accept ICICI Bank’s{" "}
                          <a
                            href="https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/docs/terms-condition/tnc-savings-account.pdf?ITM=nli_termsConditions_termsConditions_na_na_11_na_na_NLI"
                            onClick={() => {
                              eventWithFormInfo(
                                "terms & conditions",
                                "link",
                                "form"
                              );
                            }}
                            onContextMenu={handleRightCLickTC}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            Terms & Conditions
                          </a>
                          .
                        </label>
                      </div>
                      {checkbox !== "" ? (
                        <span
                          className="agree_span"
                          style={{
                            fontSize: "12px",
                            fontFamily: "Mulish, sans-serif",
                            fontStretch: "normal",
                            fontStyle: "12px",
                            fontWeight: 600,
                            lineHeight: "normal",
                            letterSpacing: "normal",
                            position: "relative",
                            color: "red",
                          }}
                        >
                          {checkbox}
                        </span>
                      ) : null}
                    </div>
                    <div className="applynow">
                      <button
                        disabled={disableApplyBtn}
                        type="submit"
                        style={{
                          backgroundColor: disableApplyBtn ? "grey" : "",
                        }}
                      >
                        {disableApplyBtn ? "Submitting..." : "Apply Now"}
                      </button>
                    </div>
                  </section>
                </form>
              )}
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Form;
